import { useState, useEffect } from "react";
import UpperLayerTabLayout from "../../../Components/DetailsPageUpperLayer/UpperLayerTabLayout";

const OutboundShipmentHeader = ({ hProps, linesData, deliveryData }) => {
  const [shipmentDetails, setShipmentDetails] = useState({});
  const [freightDetails, setFreightDetails] = useState({});
  const [trackAndTraceData, setTrackAndTraceData] = useState({});

  const fieldLabels = {
    legEta: "Leg ETA",
    legPta: "Leg PTA",
  };

  useEffect(() => {
    // Keys you want to ALWAYS show under "Shipment"
    const shipmentKeys = [
      "shipmentNo",
      //"headerTrackingReference",
      //"headerTrackingReferenceType",
      "shipmentType",
      "countryOfOrigin",
      "plannedShipDate",
      //"scacCode",
      //"containsHazmat",
      //"shipperRefNo",
      "processType",
      "creationDate",
      "supplier",
      "orderType",
      "customer",
    ];

    // Keys you want to ALWAYS show under "Transportation"
    // (Adjust to your domain as needed)
    const transportationKeys = [
      "shipMode",
      "numberOfContainers",
      //"consigneeRefNo",
      "consignee",
      "carrier",
      //"departurePort",
      //"arrivalPort",
      //"bookingNo",
      //"incoterm",
      //"imo",
      //"msi",
      "placeOfDelivery",
    ];

    const seedWithDefaults = (src, keys) =>
      keys.reduce((acc, k) => {
        acc[k] = src?.[k] ?? null; // null so the UI prints "TBD"
        return acc;
      }, {});

    // Build objects with fixed schemas so labels always render
    setShipmentDetails(seedWithDefaults(hProps || {}, shipmentKeys));
    setFreightDetails(seedWithDefaults(hProps || {}, transportationKeys));

    // Track & Trace: keep as-is (keys always present; values may be null)
    setTrackAndTraceData({
      shipFrom: deliveryData?.[0]?.ship_from ?? linesData?.[0]?.ship_from ?? null,
      shipTo: linesData?.[0]?.ship_to ?? null,
      //shipDate: linesData?.[0]?.container_ship_date ?? null,
      legEta: linesData?.[0]?.container_eta ?? null,
      //legPta: linesData?.[0]?.container_pta ?? null,
    });
  }, [hProps, linesData, deliveryData]);

  return (
    <UpperLayerTabLayout
      firstHeading="Shipment"
      secondHeading="Transportation"
      thirdHeading="Track & Trace"
      firstBoxData={shipmentDetails}
      secondBoxData={freightDetails}
      thirdBoxData={trackAndTraceData}
      showTrackAndTrace={true}
      fkLink={hProps?.fkLink}
      title="Outbound Shipments Detail"
      fieldLabels={fieldLabels}
    />
  );
};

export default OutboundShipmentHeader;
